"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _mixins = require("../../styles/mixins");
var _HBClickable = _interopRequireDefault(require("../HBClickable/HBClickable"));
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _ArrowLineDownAlt = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineDownAlt8"));
var _ArrowLineUpAlt = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLineUpAlt8"));
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _InfoCircle = _interopRequireDefault(require("@honeybook/icons/dist/icons/InfoCircle16"));
var _styledIs = _interopRequireWildcard(require("styled-is"));
var _templateObject, _templateObject2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBNewTableHeader = function HBNewTableHeader(_ref) {
  var column = _ref.column,
    onSortChange = _ref.onSortChange,
    _ref$sort = _ref.sort,
    sort = _ref$sort === void 0 ? 'none' : _ref$sort;
  var hasSort = sort !== 'none';
  return /*#__PURE__*/_react["default"].createElement(Container, {
    onClick: function onClick() {
      if (column.isSortable) {
        onSortChange(column.id);
      }
    },
    isDisabled: !column.isSortable,
    testIdName: "header-table"
  }, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "subtitle12",
    color: "textTertiary"
  }, column.title), !!column.headerTooltip && /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    target: /*#__PURE__*/_react["default"].createElement(_InfoCircle["default"], null),
    targetContainerStyle: {
      marginBottom: '-6px',
      marginLeft: '8px'
    },
    placement: "top",
    offsetY: 5
  }, column.headerTooltip), column.isSortable && /*#__PURE__*/_react["default"].createElement(_HBTooltip["default"], {
    target: /*#__PURE__*/_react["default"].createElement(ArrowWrapper, {
      $hasSort: hasSort
    }, /*#__PURE__*/_react["default"].createElement(StyledArrowLineUpAlt8, {
      isDescending: sort === 'descending'
    }), /*#__PURE__*/_react["default"].createElement(StyledArrowLineDownAlt8, {
      isDescending: sort === 'descending'
    })),
    placement: "top",
    offsetY: 5
  }, column.sortTooltip));
};
var _default = exports["default"] = HBNewTableHeader; // --- Styles ---
var StyledArrowLineUpAlt8 = (0, _styledComponents["default"])(_ArrowLineUpAlt["default"]).withConfig({
  displayName: "HBNewTableHeader__StyledArrowLineUpAlt8",
  componentId: "sc-rx9es7-0"
})(["position:absolute;top:-3px;", ";"], function (props) {
  return props.isDescending ? 'left: 0px' : 'right: 0px';
});
var StyledArrowLineDownAlt8 = (0, _styledComponents["default"])(_ArrowLineDownAlt["default"]).withConfig({
  displayName: "HBNewTableHeader__StyledArrowLineDownAlt8",
  componentId: "sc-rx9es7-1"
})(["position:absolute;bottom:-3px;", ";"], function (props) {
  return props.isDescending ? 'right: 0px' : 'left: 0px';
});
var ArrowWrapper = _styledComponents["default"].div.withConfig({
  displayName: "HBNewTableHeader__ArrowWrapper",
  componentId: "sc-rx9es7-2"
})(["opacity:0;margin-left:4px;height:13px;width:15px;position:relative;", " ", ""], (0, _styledIs["default"])('$hasSort')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        opacity: 1;\n    "]))), (0, _mixins.setIconFillColor)(_colors["default"].neutral600));
var Container = (0, _styledComponents["default"])(_HBClickable["default"]).withConfig({
  displayName: "HBNewTableHeader__Container",
  componentId: "sc-rx9es7-3"
})(["display:flex;align-items:end;&:hover,&:focus{", "{", " opacity:1;}}", ""], ArrowWrapper, (0, _mixins.setIconFillColor)(_colors["default"].neutral700), (0, _styledIs.isNot)('isDisabled')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        cursor: pointer;\n    "]))));
//# sourceMappingURL=HBNewTableHeader.js.map